import formatFixedNumber from './formatFixedNumber'

const formatCurrency = (amount, decimals = 2) => {
  const costAsCurrency = `$${formatFixedNumber(Math.abs(amount), decimals)}`

  return amount < 0 ? `(${costAsCurrency})` : costAsCurrency
}

export default formatCurrency
